import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 12a4 4 0 0 0 0-8H6v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 20a4 4 0 0 0 0-8H6v8Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bold";
const Bold = memo(themed(Icon));
export {
  Bold
};
//# sourceMappingURL=bold.js.map
